<template>
  <div ref="container" class="card-container d-inline-block my-2 mx-2">
    <div class="flip-card">
      <div class="flip-card-inner" :class="{flipped:flipped}">
        <div class="flip-card-front">
          <div class="card cool-shadow" :class="{'bg-dark text-light':darkMode}">
            <div class="card-header">
              <div class="d-flex w-100 justify-content-between">
                <h3 class="title-text text-truncate h6 m-0 flex-grow-1"
                    :title="title"
                    data-bs-toggle="tooltip"
                    data-bs-placement="auto"
                >
                  {{ title }}
                </h3>
                <span class="censorship-icon" :class="[uncensored ? 'uncensored' : 'censored']"></span>
              </div>
            </div>
            <div class="card-body p-0" v-on:click="flip">
              <img class="img-fluid w-100" :src="thumbnailImg" :alt="title + ' thumbnail'"/>
            </div>
            <div class="card-footer d-flex flex-row justify-content-between">
              <a class="anime-site-logo mal m-auto"
                 rel="nofollow"
                 v-if="mal !== null"
                 :href="url.MAL + mal"
                 target="_blank"
              >
              </a>
              <a class="anime-site-logo anidb m-auto"
                 rel="nofollow"
                 v-if="anidb !== null"
                 :href="url.ANI_DB + anidb"
                 target="_blank"
              ></a>
            </div>
          </div>
        </div>
        <div class="flip-card-back">
          <div class="card cool-shadow" :class="{'bg-dark text-light':darkMode}">
            <div class="card-header d-flex flex-row">
              <div class="flex-grow-1">Details</div>
              <button class="btn btn-xs"
                      :class="[darkMode ? 'btn-outline-light' : 'btn-outline-dark']"
                      v-on:click="flip"
              >
                <span class="fas fa-reply"></span>
              </button>
            </div>
            <div class="card-body d-flex flex-column">
              <div class="text-start flex-grow-1 card-description"
                   :title="description"
                   data-bs-toggle="tooltip"
                   data-bs-placement="auto"
              >
                {{ description }}
              </div>
              <carousel v-if="covers.length > 0" :id="id" :images="covers" :active="cardBackOpened"></carousel>
            </div>
            <div class="card-footer">
              <span class="badge bg-secondary align-top">Futa ep:</span>
              <span class="badge rounded-pill bg-info align-top"
                    v-for="(ep, index) in episodes"
                    :key="index"
              >
                {{ ep }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {url} from "@/constants";
import {Tooltip} from 'bootstrap';
import Carousel from "@/components/Carousel";
import {LOG_EVENT} from "@/services/store/firebase.module";
import store from "@/services/store";
import {IMG_GET} from "@/services/store/mal.module";

export default {
  name: 'FlipCard',
  components: {Carousel},
  props: {
    darkMode: Boolean,
    id: String,
    title: String,
    description: String,
    uncensored: Boolean,
    episodes: Array,
    thumbnail: String,
    covers: Array,
    mal: Number,
    anidb: Number
  },
  data() {
    return {
      thumbnailImg: `${url.IMGUR}/${this.thumbnail}.jpg`,
      flipped: false,
      cardBackOpened: false,
      url: url
    }
  },
  async mounted() {
    if (!this.thumbnail) {
      if (!store.getters.getImg || !store.getters.getImg.get(this.mal)) {
        await store.dispatch(IMG_GET, this.mal).catch();
      }

      this.thumbnailImg = store.getters.getImg.get(this.mal);
    }
    const tooltipElements = this.$refs.container.querySelectorAll('[data-bs-toggle="tooltip"]');

    for (const element of tooltipElements) {
      if (element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight) {
        new Tooltip(element);
      }
    }
  },
  methods: {
    flip: function () {
      this.flipped = !this.flipped;

      if (!this.cardBackOpened) {
        this.$store.commit(LOG_EVENT, {
          name: 'select_item',
          data: {
            items: [{
              item_id: this.id,
              item_name: this.title,
              //item_variant: (this.),
            }]
          }
        })
      }
      this.cardBackOpened = true;
    }
  }
}
</script>

<style scoped>
.card-body {
  height: 360px;
  overflow: hidden;
}

.flip-card-front .card-body {
  cursor: pointer;
}

.card-container {
  width: 280px;
  height: 460px;
}

.title-text {
  line-height: 24px;
}

.card-description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
  font-size: 11pt;
}

.btn-xs {
  padding: 0 .3rem;
  font-size: .9em;
  line-height: 1.5;
  border-radius: .2rem;
}

/**
 * MAL, AniDB Logos
 */

.anime-site-logo {
  height: 24px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: rgba(60, 64, 67, 0.3) 0 1px 2px 0, rgba(60, 64, 67, 0.15) 0 2px 6px 2px;
  transition: box-shadow ease-out 150ms;
}

.anime-site-logo:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0 1px 2px 0, rgba(60, 64, 67, 0.15) 0 2px 6px 2px, inset 0 0 200px #00000077;
  transition: box-shadow ease-in 150ms;
}

.anime-site-logo.anidb {
  width: 110px;
  background: #ffffff url("https://i.imgur.com/UkhkP9K.jpg") no-repeat;
  background-size: contain;
}

.anime-site-logo.mal {
  width: 104px;
  background: #2e51a2 url("https://i.imgur.com/mhJZBty.png") no-repeat;
  background-size: contain;
}

/**
 * Card Shadow
 */

.cool-shadow:before,
.cool-shadow:after {
  content: "";
  position: absolute;
  z-index: -2;
  bottom: 15px;
  left: 10px;
  width: 46%;
  height: 20%;
  max-width: 300px;
  -webkit-box-shadow: 0 15px 10px rgba(0, 0, 0, 0.7);
  -moz-box-shadow: 0 15px 10px rgba(0, 0, 0, 0.7);
  box-shadow: 0 15px 10px rgba(0, 0, 0, 0.7);
  -webkit-transform: rotate(-3deg);
  -moz-transform: rotate(-3deg);
  -ms-transform: rotate(-3deg);
  -o-transform: rotate(-3deg);
  transform: rotate(-3deg);
}

.cool-shadow:after {
  right: 10px;
  left: auto;
  -webkit-transform: rotate(3deg);
  -moz-transform: rotate(3deg);
  -ms-transform: rotate(3deg);
  -o-transform: rotate(3deg);
  transform: rotate(3deg);
}

@media (prefers-color-scheme: dark) {
  .cool-shadow {
    box-shadow: rgba(69, 69, 69, 0.25) 5px 5px,
    rgba(69, 69, 69, 0.2) 10px 10px,
    rgba(69, 69, 69, 0.1) 15px 15px
  }

  .cool-shadow:before,
  .cool-shadow:after {
    display: none;
  }
}

/**
 * Flipping Card
 */

.flip-card {
  background-color: transparent;
  -webkit-perspective: 1000px;
  -moz-perspective: 1000px;
  perspective: 1000px
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

.flip-card-front, .flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: -webkit-transform 1s;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-back {
  -webkit-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
}

.flipped {
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
</style>
